import { render, staticRenderFns } from "./GigJobStatusBadge.htm?vue&type=template&id=2e6b6bea&"
import script from "./GigJobStatusBadge.ts?vue&type=script&lang=js&"
export * from "./GigJobStatusBadge.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports